import React, { Fragment, useState } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Card, CardHeader } from 'reactstrap';

export const CardSelect = (props) => {

    const { cards, setCards, searchAction, placeholder, fromSessionPage } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const ref = React.createRef();
    const filterBy = () => true;

    const handleSearch = async (query) => {
        try {
            setIsLoading(true);
            const options = await searchAction(query);
            setOptions(options);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }

    const handleDelete = (card) => {
        const _cards = cards.filter(c => c.value !== card.value)
        setCards([..._cards]);
    };

    const handleAdd = (card) => {
        setCards([...cards, card])
        if (ref && ref.current)
            ref.current.clear()
    };

    const renderCards = () => {
        return cards?.map((c) => (
            <Card className="mb-2" key={c ? c.value : null}>
                <CardHeader>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="">
                            {c ? c.label : null}
                        </div>
                        <button onClick={() => handleDelete(c)} className="btn btn-danger">
                            Delete
                        </button>
                    </div>
                </CardHeader>
            </Card>
        ))
    }

    return (
        <div className="row">
            <div className="col-12 mb-2">
                <AsyncTypeahead
                    ref={ref}
                    onChange={(e) => {
                        handleAdd(e[0])
                    }}
                    allowNew={false}
                    filterBy={filterBy}
                    id="async-example"
                    isLoading={isLoading}
                    labelKey="value"
                    minLength={2}
                    onSearch={handleSearch}
                    options={options}
                    placeholder={placeholder}
                    renderMenuItemChildren={(option, props) => (
                        <Fragment>
                            <span>{option.label}</span>
                        </Fragment>
                    )}
                    style={fromSessionPage ? { height: '51px' } : {}}
                />
            </div>
            <div className="col-12">
                {renderCards()}
            </div>
        </div>
    )

}